import { LOADING_IMAGE } from "../../common/constants";
import ImageHelper from "../image-helper";
export default class ImageLoader {
  inserted(el) {
    el.src = LOADING_IMAGE;
  }

  update(el, binding) {
    //if (binding.value != binding.oldValue) {
      ImageLoader.loadImage(el, binding);
    //}
  }

  bind(el, binding) {
    el.style.objectFit = "scale-down";
    ImageLoader.loadImage(el, binding);
  }

  static loadImage(el, binding) {
    ImageHelper.populateImageUrl(el, binding.value, true);
  }
}
